import { engeniApi } from '@/api/engeni.api';
import type { ApiResponseData, ApiResponsePaginated } from '@/interfaces/api.interface';
import type { Project, ProjectBriefStatus } from '../interfaces/project.interface';
import type {
  ProjectConfigurationTask,
  ProjectConfigurationTaskStatus,
} from '../interfaces/configurationTask.interface';
import type { Domain, DomainLookup } from '../interfaces/domain.interface';
import type { ProjectMonitorStats } from '../interfaces/projectMonitorStats.interface';

const BASE_PATH = '/clee';
//const BASE_PUBLIC_PATH = `/public${BASE_PATH}`;

export const cleeService = {
  async getProjectsByAccountId(account_id: number) {
    return await engeniApi.get<ApiResponseData<Project[]>>(
      `${BASE_PATH}/projects?filter[account_id]=${account_id}&no_pagination=1`,
    );
  },
  async getProjectById(project_id: number) {
    return await engeniApi.get<ApiResponseData<Project>>(`${BASE_PATH}/projects/${project_id}`);
  },
  async updateProject(project_id: number, data: Partial<Project>) {
    return await engeniApi.put<ApiResponseData<Project>>(
      `${BASE_PATH}/projects/${project_id}`,
      data,
    );
  },
  async updateProjectBriefStatus(
    project_id: number,
    payload: { brief_status: ProjectBriefStatus; brief_comments: string },
  ) {
    return await engeniApi.patch<ApiResponseData<Project>>(
      `${BASE_PATH}/projects/${project_id}/brief/status`,
      payload,
    );
  },
  async getProjectConfigurationTasks(project_id: number) {
    return await engeniApi.get<ApiResponseData<ProjectConfigurationTask[]>>(
      `${BASE_PATH}/projects/${project_id}/configuration-tasks`,
    );
  },
  async updateProjectConfigurationTaskStatus(
    project_id: number,
    project_configuration_task_id: number,
    data: { status: ProjectConfigurationTaskStatus; notes?: string },
  ) {
    return await engeniApi.patch<ApiResponseData<ProjectConfigurationTask>>(
      `${BASE_PATH}/projects/${project_id}/configuration-tasks/${project_configuration_task_id}/status`,
      data,
    );
  },
  async getDomainsByAccountId(account_id: number) {
    return await engeniApi.get<ApiResponsePaginated<Domain[]>>(
      `${BASE_PATH}/domains?account_id=${account_id}&per_page=100`,
    );
  },
  async lookupDomain(domain: string) {
    return await engeniApi.post<ApiResponseData<DomainLookup>>(`${BASE_PATH}/domains/lookup`, {
      domain_name: domain,
    });
  },
  async registerDomainByProjectId(domain: string, project_id: number) {
    return await engeniApi.post<ApiResponseData<Domain>>(
      `${BASE_PATH}/projects/${project_id}/integrations/domains/register`,
      {
        domain_name: domain,
      },
    );
  },
  async getProjectMonitorStats(project_id: number, filter?: Record<string, any>) {
    return await engeniApi.get<ApiResponseData<ProjectMonitorStats[]>>(
      `${BASE_PATH}/projects/${project_id}/monitors`,
      {
        params: { ...filter },
      },
    );
  },
};
